import React from "react";

import { t } from "i18next";
import swal from "@sweetalert/with-react";

import { setIsLoading } from "../../../store/project";
import { NoPicture } from "@components/Common/SvgIcons/NoPicture";

import { useFetchGlobal } from "../../../api/hooks";
import UploadIcon from "@components/Common/SvgIcons/UploadIcon";

type UploaderPropsType = {
    active: boolean;
    file: any;
    setFile: any;
    ticketType: string;
    disabled?: boolean;
};

export function Uploader({
    active,
    file,
    setFile,
    ticketType,
    disabled,
}: UploaderPropsType): JSX.Element {
    const validUploadedTypes = ["image/png"];
    const { fetchGlobal } = useFetchGlobal();
    const acceptedInputTypes = validUploadedTypes?.join(",");

    const [displayImage, setDisplayImage] = React.useState("");

    async function handleUpdatingUploadDataOnChangeEvent(
        event: React.ChangeEvent<HTMLInputElement>
    ) {
        const fileTarget = event.target?.files;
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/upload/${ticketType}`;
        if (fileTarget !== null) {
            const formData = new FormData();
            formData.append("file", (fileTarget as FileList)[0]);
            if (
                !validUploadedTypes.includes((fileTarget as FileList)[0].type)
            ) {
                return swal({
                    icon: "error",
                    content: <p>{t("File type is not valid")}!</p>,
                    buttons: false,
                    timer: 2000,
                });
            }

            if ((fileTarget as FileList)[0]) {
                const reader = new FileReader();

                reader.onloadend = () => {
                    setDisplayImage(reader.result as any);
                };

                reader.readAsDataURL((fileTarget as FileList)[0]);
            }
            try {
                const result: any = await fetchGlobal(apiUrl, {
                    body: formData,
                    method: "PUT",
                });

                if (result.error) {
                    throw new Error(result.message);
                }
                setFile(result.data);

                setIsLoading(false);

                swal({
                    icon: "success",
                    content: <p>{t("Logo loaded successfully.")}</p>,
                    buttons: false,
                    timer: 2000,
                });

                setTimeout(() => {
                    setDisplayImage(result.data);
                }, 3000);
            } catch (error: any) {
                console.error("Upload failed:", error);
                setIsLoading(false);

                swal({
                    icon: "error",
                    content: <p>{t(error.message)}</p>,
                    buttons: false,
                    timer: 2000,
                });
            }
        }
    }
    React.useEffect(() => {
        setDisplayImage(file);
        // eslint-disable-next-line
    }, [file]);

    return (
        <div
            className="d-flex align-items-center"
            style={{
                gap: "5px",
            }}
        >
            <div
                className="text-truncate"
                style={{
                    width: active ? "150px" : "unset",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                }}
            >
                {t("Load logo")}
            </div>
            {active &&
                (file === "" && displayImage === "" ? (
                    <NoPicture
                        height="35px"
                        width="40px"
                        className="flag__clz"
                    />
                ) : (
                    <img
                        alt="nopicture.png"
                        src={displayImage === "" ? file : displayImage}
                        height={50}
                        width={50}
                    />
                ))}
            <label
                className="d-flex align-items-center"
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    margin: 0,
                }}
            >
                <UploadIcon height={40} width={40} />
                <input
                    accept={acceptedInputTypes}
                    multiple={false}
                    type="file"
                    title="input"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        handleUpdatingUploadDataOnChangeEvent(event);
                    }}
                    onClick={(event: any) => {
                        event.currentTarget.value = "";
                    }}
                    disabled={disabled}
                />
            </label>
        </div>
    );
}
